import axios from './HTTP';

export default {
  getAll(callback) {
    axios.get('/api/resources.json').then(response => callback(response.data));
  },

  getRoots(callback) {
    axios
      .get('/api/resource_categories.json')
      .then(response => callback(response.data));
  },

  create(params, callback, errorCallback) {
    axios
      .post(`/api/resources.json`, params)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  update(resourceObject, callback, errorCallback) {
    axios
      .patch(`/api/resources/${resourceObject.id}.json`, {
        resource: resourceObject,
      })
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  destroy(id, callback, errorCallback) {
    axios
      .delete(`/api/resources/${id}.json`)
      .then(response => callback(response.data))
      .catch(err => errorCallback(err));
  },

  destroyCategory(id, callback, errorCallback) {
    axios
      .delete(`/api/resource_categories/${id}.json`)
      .then(response => callback(response.data))
      .catch(err => errorCallback(err));
  },

  updateCategory(category, callback, errorCallback) {
    axios
      .patch(`/api/resource_categories/${category.id}.json`, {
        category: category,
      })
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  moveCategoryHigher(category, callback, errorCallback) {
    axios
      .patch(`/api/resource_categories/${category.id}/move_higher.json`)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  moveCategoryLower(category, callback, errorCallback) {
    axios
      .patch(`/api/resource_categories/${category.id}/move_lower.json`)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  createCategory(params, callback, errorCallback) {
    axios
      .post(`/api/resource_categories.json`, params)
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },
};
